import { render, staticRenderFns } from "./ConfigurationsNav.vue?vue&type=template&id=a09b1bcc&"
import script from "./ConfigurationsNav.vue?vue&type=script&lang=js&"
export * from "./ConfigurationsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports